exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\t.palel-primary\r\n\t{\r\n\t\t\r\n\t}\r\n\t.panel-primary>.panel-heading\r\n\t{\r\n\t\tbackground:#bce8f1;\r\n\t\t\r\n\t}\r\n\t.panel-primary>.panel-body\r\n\t{\r\n\t\tbackground-color: #EDEDED;\r\n\t}\r\n*/\r\n\r\n\r\n.th\r\n{\r\n    \r\n   background-color:\"gray\";\r\n}\r\n.panel-heading\r\n{\r\n\r\n}\r\n.master-panel\r\n{\r\n    \r\n/*     margin-top: 20px; */\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/interviewrating/interviewrating.component.css
// module id = ../../../../../src/app/interviewrating/interviewrating.component.css
// module chunks = main